<div [ngClass]="lang === 'en' ? 'stepper_en' : 'stepper_ar'" ></div>
